import * as React from 'react';
import { Stack, StackProps, Typography } from '@mui/material';

export type SectionHeaderProps = StackProps & {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'left' | 'center';
};

export function SectionHeader({
  title,
  subtitle,
  align = 'left',
  sx,
  ...props
}: SectionHeaderProps) {
  const isCentered = align === 'center';

  return (
    <Stack
      spacing={1}
      sx={{
        textAlign: align,
        alignItems: isCentered ? 'center' : 'flex-start',
        ...sx,
      }}
      {...props}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: '1.8rem', md: '2.35rem' },
          letterSpacing: '0.03em',
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: isCentered ? 760 : 860 }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
}
